module.exports = __webpack_public_path__ + "static/media/bonair4.9a90e155.JPG";